export default __webpack_public_path__ + "static/baby-unicorn-56c5f74c624f23d1a39e36398a1d8871.jpeg";